import React from 'react';
import { withStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { getParameterByName } from '../../utils/utils';
import moment from 'moment';
import apiManager from '../../ApiManager';
import { PLAYER_BASE_URL, ORGANIZATION_ALIAS } from '../../constants';

// import ag101Logo from '../../images/SHA/ag101logo.png';
// import { HORIZONTAL_LOGO as ag101Logo } from '../../constants';
// import RegenAg10101 from '../../assets/classes/regenAg101-01.json';
import ag101CertImage from '../../images/SHA/RegenAg101CertificateOfCompletion.png';
const CheaterDialog = ({ open, handleClose }) => (
  <div>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="cheater-dialog-title"
      aria-describedby="cheater-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        No Active Subscription Found
      </DialogTitle>
      <DialogContent>
        <p id="cheater-dialog-description">
          Unfortunately, it doesn't seem you are subscribed to this course.
        </p>
        <p>Please subscribe and try again.</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Contine
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);
const styles = theme => ({
  root: {
    paddingTop: 120,
    fontFamily: 'Helvetica',
    '@media only screen and (max-width: 450px)': {
      marginLeft: 0,
      paddingTop: 54,
    },
  },
  logo: {
    width: '100%',
    margin: '0px auto 40px',
    fontSize: 24,
    textAlign: 'center',
    fontWeight: 'bold',
    '@media only screen and (max-width: 450px)': {
      width: 150,
      margin: '12px auto 26px',
    },
  },
  logoimg: {
    flexShrink: 0,
    minWidth: '100%',
    minHeight: '100%',
    maxWidth: '100%',
  },

  table: {
    fontSize: 18,
    '@media only screen and (max-width: 450px)': {
      fontSize: 12,
    },
  },
  headerRow: {
    background: '#67b1e2',
  },
  oddRow: {
    background: '#ccc',
  },
  columnhidemobile: {
    '@media only screen and (max-width: 450px)': {
      display: 'none',
    },
  },
  tc: {
    fontSize: 18,
    '@media only screen and (max-width: 450px)': {
      fontSize: 12,
    },
  },
  tch: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'white',
    '@media only screen and (max-width: 450px)': {
      fontSize: 12,
    },
  },

  contentarea: {
    paddingLeft: 32,
    paddingRight: 54,
    marginBottom: 54,
    color: '3d3d3d',
    '@media only screen and (max-width: 450px)': {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
});

export class MyClasses extends React.PureComponent {
  constructor(...args) {
    super(...args);

    const { user, apiManager, history, updateUser } = this.props;

    const currentCourse = getParameterByName('course');
    const courseCompleted = getParameterByName('completion');
    const allAvailable = getParameterByName('all-available');
    const testDate = getParameterByName('test-date');
    const impersonate = getParameterByName('im');
    const demoMode = localStorage.getItem('demoMode');
    const organization = localStorage.getItem('organization');

    this.state = {
      user, // TODO: Not set yet. Need to adjust udpateUser to used Cognito info to pull in info from DB.
      apiManager,
      history,
      currentCourse,
      courseCompleted,
      completionDate: moment().format('MM/DD/YYYY'),
      allAvailable,
      testDate,
      progress: [],
      moduleProgress: {},
      progressLoaded: false,
      tries: 0,
      demoMode,
      organization: organization ? JSON.parse(organization) : { courses: [] },
      cheaterOpen: false,
      impersonate,
    };
  }

  componentDidMount = async () => {
    // Get the current JWT
    // const attributes = await apiManager.currentAttributes();
    const { accessToken } = await apiManager.currentSession();

    let courseInfo = false;
    this.state.organization.courses.forEach(course => {
      if (course.alias === this.state.currentCourse) {
        courseInfo = course;
      }
    });
    if (!courseInfo) {
      this.state.history.push('/');
      return;
    }

    const id = this.state.user.sub;
    const userMe = await apiManager.getUserMe(id, ORGANIZATION_ALIAS);
    const now = moment();
    const subscriptions = [];
    const subscriptionData = {};
    let isSubscribed = false;
    let isExpired = false;
    let completedCount = '0/0';
    let completed = false;
    if (userMe && userMe.registrations) {
      userMe.registrations.forEach(reg => {
        if (
          reg.organization &&
          (reg.organization.name === ORGANIZATION_ALIAS ||
            reg.organization.name === 'sha') &&
          reg.organization.subscriptions &&
          reg.organization.subscriptions.length > 0
        ) {
          reg.organization.subscriptions.forEach(sub => {
            // TODO: Verify isSubscribed works here or move the cancelled/expired logic somewhere else
            if (
              this.state.currentCourse === sub.courseNameAlias &&
              sub.isSubscribed === true
            ) {
              // TODO: check expiration date!
              subscriptions.push(sub.courseNameAlias);
              subscriptionData[sub.courseNameAlias] = sub;
              if (sub.status === 'cancelled' || now.isAfter(sub.endDate)) {
                isExpired = true;
              } else {
                isSubscribed = true;
              }
              completedCount = sub.completeCount || '0/1';
              completed = sub.completed;
            }
          });
        }
      });
    }

    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };

    if (
      !isSubscribed &&
      !this.state.testDate &&
      !this.state.courseCompleted &&
      !isExpired
    ) {
      this.setState({
        cheaterOpen: true,
      });
      return;
    }

    const newUser = {
      token: accessToken.jwtToken,
      isSubscribed,
    };
    this.setState({
      user: newUser,
      token: accessToken.jwtToken,
      isSubscribed,
      isExpired,
      courseInfo,
      completionDate: this.state.completionDate,
    });

    this.getClassesProgress();
    var element = document.getElementById('myclasses-page');
    element.scrollIntoView({ behavior: 'smooth', align: true });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const p = this.props;
    const pp = prevProps;
    const s = this.state;
    const ps = prevState;
  };

  handleNameInput = event => {
    event.persist();
    this.setState({ newName: event.target.value });
  };

  getClassesProgress = async () => {
    setTimeout(async () => {
      const progress = await apiManager.getClassProgress(
        this.state.organization.organization.alias,
        this.state.currentCourse,
        this.state.impersonate
      );
      const moduleProgress = {};

      let completedCount = 0;
      let activeClasses = 0;
      const classNames = [
        'class00',
        'class01',
        'class02',
        'class03',
        'class04',
        'class05',
        'class06',
        'class07',
        'class08',
        'class09',
      ];
      if (progress) {
        const { courseProgress } = progress;
        courseProgress.forEach(nextClass => {
          let status = 'Available';
          let button = 'Start';
          let continueFrom = 0;
          let percentComplete = 0;
          let endTime = 0;
          if (nextClass.loaded === true && nextClass.alias !== '') {
            activeClasses++;
            status = 'In Progress';
            button = 'Resume';
            const duration = parseFloat(nextClass.asset.duration);
            // find the furthest playhead event
            endTime = nextClass.maxTimeStamp || 0;
            // nextClass.metrics.forEach(metric => {
            //     if (metric.timestamp > endTime) {
            //         endTime = metric.timestamp;
            //     }
            // })
            if (endTime + 5 >= duration) {
              endTime = duration;
              status = 'Completed';
              button = 'Replay';
              if (classNames.includes(nextClass.alias)) {
                completedCount++;

                console.log('completed: ', completedCount);
                // debugger;
                // if( (completedCount+1) === courseProgress.length) {
                //     this.setState({courseCompleted: true})
                // }
              }
            } else {
              continueFrom = endTime;
              percentComplete = duration > 0 ? (endTime * 100) / duration : 0;
            }
          }
          moduleProgress[nextClass.alias] = {
            status,
            continueFrom,
            percentComplete,
            button,
          };
          console.log(
            nextClass.alias,
            ' - ',
            percentComplete,
            ' - endTime: ',
            endTime
          );
        });
        if (this.state.courseInfo.classes.length === completedCount) {
          this.setState({ courseCompleted: true });
        }
      }

      //  this.setState({progress: progress.courseProgress, moduleProgress}, () => {
      this.setState({ moduleProgress }, () => {
        this.setState({ progressLoaded: true });
      });
    }, 500);
  };

  startClass = async index => {
    const classNumber = index < 10 ? `class0${index}` : `class${index}`;
    const result = await apiManager.getClassCode();

    if (result && result.classCode) {
      let params = '';
      const { moduleProgress } = this.state;
      if (moduleProgress[classNumber]) {
        const continueFrom = moduleProgress[classNumber].continueFrom;
        if (continueFrom > 0) {
          params = `?continuefrom=${parseInt(continueFrom)}`;
        }
      }

      const courseName = `${this.state.courseInfo.alias}${
        this.state.demoMode ? '' : ''
      }`; // was '-demo'
      const orgAlias = this.state.organization.organization.alias;
      const classUrl = `${PLAYER_BASE_URL}/#/class/${orgAlias}/${courseName}/${classNumber}/${result.classCode}${params}`;
      this.setState({ playingClass: true }, () => {
        window.location = classUrl;
      });
    } else {
      alert(
        `We're sorry, but there is an issue connecting to the player.  Please try again in a few minutes.`
      );
    }
  };

  goToCertPage = () => {
    window.location = `/myclasses/completion/print/option?im=${this.state.courseInfo.certificate}&date=${this.state.completionDate}`;
  };

  classProgress = index => {
    const courseNameAlias = index < 10 ? `class0${index}` : `class${index}`;
    let status = '';
    let continueFrom = 0;
    let percentComplete = 0;
    const { moduleProgress } = this.state;
    if (moduleProgress[courseNameAlias]) {
      status = moduleProgress[courseNameAlias].status;
      continueFrom = moduleProgress[courseNameAlias].continueFrom;
      percentComplete = moduleProgress[courseNameAlias].percentComplete;
    }
    return { status, continueFrom, percentComplete };
  };

  classAvailable = index => {
    if (this.state.allAvailable) {
      return true;
    }

    const avdate = this.state.courseInfo.classes[index].available;
    if (this.state.testDate) {
      const today = moment(this.state.testDate);
      const before = moment(avdate).isSameOrBefore(today, 'day');
      return before;
    }
    const today = moment();
    const before = moment(avdate).isSameOrBefore(today, 'day');
    return before;
  };

  showStatus = index => {
    const available = this.classAvailable(index);
    if (this.state.allAvailable || available) {
      const progress = this.classProgress(index);
      if (progress.status === 'Completed') {
        return (
          <span>
            <b>&#x2714; Completed</b>
          </span>
        );
      }
      if (progress.status === 'In Progress') {
        return (
          <span>
            {progress.status}
            <br />
            <LinearProgress
              variant="determinate"
              value={progress.percentComplete}
            />
            {parseInt(progress.percentComplete)}% complete
          </span>
        );
      }
      return (
        <span>
          {progress.status
            ? progress.status === 'Available' && this.state.isExpired
              ? 'Expired'
              : progress.status
            : ''}
        </span>
      );
    }
    const today = moment();
    const courseBefore = moment(this.state.courseInfo.available).isSameOrBefore(
      today,
      'day'
    );
    return (
      <span>
        {`Available: ${moment(
          courseBefore
            ? this.state.courseInfo.classes[index].available
            : this.state.courseInfo.available
        ).format('MMM D, YYYY')}`}
      </span>
    );
  };

  classDisabled = index => {
    if (this.state.allAvailable) {
      return false;
    }
    if (this.state.demoMode && index > 1) {
      return true;
    }
    if (this.state.isExpired) {
      return true;
    }
    const available = this.classAvailable(index);
    return !available;
  };

  classButtonLabel = index => {
    const available = this.classAvailable(index);
    if (this.state.allAvailable || available) {
      const courseNameAlias = index < 10 ? `class0${index}` : `class${index}`;
      let button = 'Start';
      const { moduleProgress } = this.state;
      if (moduleProgress[courseNameAlias]) {
        button = moduleProgress[courseNameAlias].button;
      }
      return button;
    }

    return 'Unavailable';
  };
  handleClose = () => {
    this.setState({
      cheaterOpen: false,
    });
    this.props.history.push('/');
  };
  render() {
    const { classes } = this.props;

    // console.log('SES: ', this.state);
    const { isSubscribed } = this.state;

    return (
      <div id="myclasses-page" className={classes.root}>
        {/* content */}
        <Grid container spacing={0} style={{ marginLeft: 4 }}>
          {/* center panel content */}
          <Grid item sm={12}>
            <div className={classes.contentarea}>
              <div
                className={classes.logo}
                style={{
                  marginBottom: `${this.state.courseCompleted ? '86px' : ''}`,
                  minHeight: `${this.state.courseCompleted ? '64px' : ''}`,
                }}
              >
                {this.state.courseInfo && (
                  <img src={this.state.courseInfo.logo} width="150" />
                )}

                {this.state.courseCompleted && this.state.courseInfo && (
                  <div
                    onClick={this.goToCertPage}
                    style={{
                      position: 'absolute',
                      top: 86,
                      right: 118,
                      textAlign: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <span
                      style={{
                        lineHeight: '30px',
                        fontWeight: 'bold',
                        color: '#679438',
                      }}
                    >
                      Course Complete
                    </span>
                    <br />
                    <img
                      src={this.state.courseInfo.certificate}
                      width="150px"
                    />
                    <br />
                    <Button size="small">Print Your Certificate</Button>
                  </div>
                )}
              </div>

              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.headerRow}>
                    <TableCell></TableCell>
                    <TableCell align="left" className={classes.tch}>
                      Class
                    </TableCell>
                    <TableCell
                      align="left"
                      className={`${classes.tch} ${classes.columnhidemobile}`}
                    >
                      Instructor
                    </TableCell>
                    <TableCell align="left" className={classes.tch}>
                      Status
                    </TableCell>
                    <TableCell
                      align="right"
                      className={classes.tch}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                {this.state.courseInfo &&
                  this.state.courseInfo.classes.map((nextClass, index) => (
                    <TableRow className={index % 2 == 0 ? '' : classes.oddRow}>
                      <TableCell className={classes.tc}>{index}</TableCell>
                      <TableCell className={classes.tc}>
                        {nextClass.name}
                      </TableCell>
                      <TableCell
                        className={`${classes.tc} ${classes.columnhidemobile}`}
                      >
                        {nextClass.instructor}
                      </TableCell>
                      <TableCell className={classes.tc}>
                        {this.state.progressLoaded === true ? (
                          <>{this.showStatus(index)}</>
                        ) : (
                          <LinearProgress />
                        )}
                      </TableCell>
                      <TableCell>
                        {this.state.progressLoaded === true ? (
                          <>
                            {this.classAvailable(index) && (
                              <Button
                                variant="contained"
                                color="primary"
                                disabled={this.classDisabled(index)}
                                onClick={() => this.startClass(index)}
                              >
                                {this.classButtonLabel(index)}
                              </Button>
                            )}
                          </>
                        ) : (
                          <div style={{ width: 100, height: 1 }}> </div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </Table>
            </div>
          </Grid>
        </Grid>
        {this.state.cheaterOpen && (
          <CheaterDialog
            open={this.state.cheaterOpen}
            handleClose={this.handleClose}
          />
        )}
      </div>
    );
  }
}

MyClasses.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  apiManager: PropTypes.object,
  updateUser: PropTypes.func,
};

export default withStyles(styles)(MyClasses);
